import Title from '@/components/InspectionReport/Items/Questions/Title';
import Response from '@/components/InspectionReport/Items/Questions/Response';
import ImageDrawing from '@/components/InspectionReport/Items/Questions/ImageDrawing';

export default {
    functional: true,
    props: {
        item: {
            type: Object,
            required: true,
        },
        resource: {
            type: Object,
            default: null,
        },
    },
    render(h, { props, data }) {
        let response;

        if (props.item.responded && props.item.response) {
            response = h(ImageDrawing, {
                props: {
                    image: props.item.params.image,
                    drawing: props.item.response.drawing,
                },
            });
        } else {
            response = null;
        }

        return h(
            'div',
            {
                'class': ['avoid-page-break', data.class, data.staticClass], // eslint-disable-line quote-props
            },
            [
                h(Title, {}, props.item.title),
                h(Response, { props: { responded: props.item.responded === true } }, [
                    response,
                ]),
            ],
        );
    },
};
